<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
      <mdb-input
        label="Nombre de ideologia"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      ></mdb-input>

      

      <div class="form-group" >
        <label class="typo__label">
          Estado
        </label>
        <multiselect
          v-model="state"
          placeholder="Seleccione el estado"
          label="name"
          track-by="id"
          :options="states"
           @select="getCodPostales"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <div class="form-group" v-if="state.hasOwnProperty('id')">
        <label class="typo__label">
          Cod.Postales
        </label>
        <multiselect
          v-model="codPostales_selected"
          placeholder="Seleccione el estado"
          label="name"
          track-by="id"
          :options="codPostales"
          :multiple="true"
          :taggable="true"
        ></multiselect>
      </div>

      <!--<label>Estrategias</label>
      <multiselect
        v-model="strategyActionsSelected"
        placeholder="Estrategias de acción"
        class="mb-3"
        label="name"
        track-by="id"
        :options="strategyActions"
        :multiple="true"
      ></multiselect>-->


      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import Multiselect from "vue-multiselect";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      state:{},
      states:[],
      codPostales:[],
      codPostales_selected:[],
      reach_estimate: 0,
      
    };
  },
  async mounted() {
    var respuesta = await this.getStates();
    
  },
  methods: {
    crear(event) {
      event.target.classList.add("was-validated");
      var { name, state, codPostales_selected } = this;
      this.isLoading = true;
      if (name == "") {
        this.isLoading = false;
      } else {
        var zip_ids =[]
        codPostales_selected.map(i => {
          zip_ids.push(i.id);
        });
        var rule = {
          name,
          state_id: state.id,
          state_selected:state,
          zip_ids,
          zips:codPostales_selected
        };
        store.dispatch("newIdeology", rule).then(() => {
          this.name = "";
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    async getStates(){
      var states = store.getters.getStates;
      if (states.length == 0) {
        await store.dispatch("getStates","").then(() => {
          var states = store.getters.getStates;
          this.states= states;
        });
      } else {
        this.states = states;
        return;
      }
    },
    async getCodPostales(opcion){
      var state_id = opcion.id;
      await store.dispatch("getCodPostalesState",state_id).then(() => {
          var codPostales = store.getters.getCodPostales;
          this.codPostales= codPostales;
        });
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>